const barChartValueGetter = (params) => params.data.resultats?.abcdk;

export default barChartValueGetter;
